import React, { useEffect, useState } from 'react';
import MuiTable from '../../../components/MuiTable/MuiTable';
import Button from '../../../components/Button/Button';
import {
  updateDownloadID,
  updateFlashBar,
  updateIsLoading,
} from '../../../redux/action';
import { useDispatch, useSelector } from 'react-redux';
import instance from '../../../service/axiosInstane';
import { errorMessage } from '../../../config/errorsMsg';
import { flashBarTheme } from '../../../config/flashBar';
import { useParams } from 'react-router-dom';
import { SortOrderType } from '../../../config/enum';
import { handlingMoreCharactor, totalPages } from '../../../config/helpers';
import qs from 'qs';
import { StateProps } from '../../../redux/reducer';
import { successMessage } from '../../../config/keyword';
import EllipsisHanlder from '../../../components/Ellipsis/EllipsisHanlder';

type KeywordJobProps = {
  status: number;
  documentsStoreId: string;
  errorDocumentsStoreId: string;
  createdBy: string;
  createdDate: string;
  message: string;
  organizationId: string;
  categoryId: string;
  organizationName: string;
  categoryName: string;
  jobName: string;
};

const columns = [
  {
    id: 'jobName',
    label: 'Job Name',
    minWidth: 70,
    align: 'left',
  },
  { id: 'createdDate', label: 'Created Date', minWidth: 110, align: 'center' },
  { id: 'status', label: 'Status', minWidth: 100, align: 'left' },
  {
    id: 'src-download',
    label: 'Source File',
    minWidth: 100,
    align: 'center',
  },
  {
    id: 'err-download',
    label: 'Error File',
    minWidth: 100,
    align: 'center',
  },
];

const Bulkupload = (props: any) => {
  const { id } = useParams();
  const userInfo = useSelector((state: StateProps) => state.tokenInfo.userInfo);
  const dispatch = useDispatch();
  const [file_upload, setFile_upload] = useState<any>(null);
  const [fileName, setFileName] = useState('');
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(20);
  const [requestJob, setRequestJob] = useState<any>({
    OrganizationFilter: [userInfo.organizationId],
    CategoryFilter: [id],
    StatusFilter: [],
    Page: page,
    PageSize: limit,
    SearchText: '',
    SortBy: '',
    SortOrder: SortOrderType.ASC,
  });
  const [state, setState] = useState<KeywordJobProps[]>([
    {
      status: 0,
      documentsStoreId: '',
      errorDocumentsStoreId: '',
      createdBy: '',
      createdDate: '',
      message: '',
      organizationId: '',
      categoryId: '',
      organizationName: '',
      categoryName: '',
      jobName: '',
    },
  ]);

  const [totalRowCount, setTotalRowCount] = useState<number>(0);

  useEffect(() => {
    getJobs(requestJob);
  }, []);

  const handleFileChange = (e: any) => {
    const selectedFile = e.target.files[0];
    setFileName(e.target.files[0].name);

    if (selectedFile) {
      // Check if the file type is allowed (CSV or Excel)
      if (
        selectedFile.type ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        selectedFile.type === 'application/vnd.ms-excel'
      ) {
        setFile_upload(selectedFile);
        // File is allowed, you can proceed with your logic
        // For example, you can upload the file or read its contents.
      } else {
        // File type is not allowed, show an error message or handle it accordingly.
        alert('Invalid file type. Please select an Excel file.');
      }
    }
  };
  const getJobs = async (obj: any) => {
    dispatch(updateIsLoading(true));
    const queryString = qs.stringify(obj, { arrayFormat: 'repeat' });
    const url = `/categories/keyword-jobs?${queryString}`;
    await instance
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          gotResponse(response.data);
        }
      })
      .catch(() => {
        const obj = {
          isOpen: true,
          message: errorMessage.oops,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };
  const gotResponse = (data: any) => {
    setTotalRowCount(data.totalCount);
    setState(data.results);
    dispatch(updateIsLoading(false));
  };

  const sorting = (sortOrder: string) => {
    let temp = '';
    if (sortOrder == SortOrderType.DESC) {
      temp = SortOrderType.ASC;
    } else {
      temp = SortOrderType.DESC;
    }
    setRequestJob({ ...requestJob, SortOrder: temp });
    return temp;
  };
  const sortRecord = (fieldName: string, sortOrder: string) => {
    getJobs({
      ...requestJob,
      SortOrder: sorting(sortOrder),
      SortBy: fieldName,
      Page: page,
      PageSize: limit,
    });
    setRequestJob({
      ...requestJob,
      sortBy: fieldName,
      sortOrder: sorting(sortOrder),
    });
  };

  const paginateHandler = {
    onClickPageNumber: (page: number) => {
      getJobs({
        ...requestJob,
        Page: page,
        PageSize: limit,
        SortBy: requestJob.SortBy,
        SortOrder: requestJob.SortOrder,
      });
      setPage(page);
    },

    onNextClick: () => {
      if (page < totalPages(totalRowCount, limit)) {
        getJobs({
          ...requestJob,
          Page: page + 1,
          PageSize: limit,
          organizationFilter: requestJob.OrganizationFilter,
          CategoryFilter: requestJob.CategoryFilter,
          StatusFilter: requestJob.StatusFilter,
          SortBy: requestJob.SortBy,
          SortOrder: requestJob.SortOrder,
        });
        setPage(page + 1);
      }
    },
    onPrevClick: () => {
      if (page > 1) {
        getJobs({
          ...requestJob,
          Page: page - 1,
          PageSize: limit,
          organizationFilter: requestJob.OrganizationFilter,
          CategoryFilter: requestJob.CategoryFilter,
          StatusFilter: requestJob.StatusFilter,
          SortBy: requestJob.SortBy,
          SortOrder: requestJob.SortOrder,
        });
        setPage(page - 1);
      }
    },
    onFirstClick: () => {
      if (page !== 1) {
        getJobs({
          ...requestJob,
          Page: 1,
          PageSize: limit,
          organizationFilter: requestJob.OrganizationFilter,
          CategoryFilter: requestJob.CategoryFilter,
          StatusFilter: requestJob.StatusFilter,
          SortBy: requestJob.SortBy,
          SortOrder: requestJob.SortOrder,
        });
        setPage(1);
      }
    },
    onLastClick: () => {
      if (page !== totalPages(totalRowCount, limit)) {
        getJobs({
          ...requestJob,
          Page: totalPages(totalRowCount, limit),
          PageSize: limit,
          organizationFilter: requestJob.OrganizationFilter,
          CategoryFilter: requestJob.CategoryFilter,
          StatusFilter: requestJob.StatusFilter,
          SortBy: requestJob.SortBy,
          SortOrder: requestJob.SortOrder,
        });
        setPage(totalPages(totalRowCount, limit));
      }
    },

    limitHandler: (item: number) => {
      getJobs({
        ...requestJob,
        Page: 1,
        PageSize: item,
        organizationFilter: requestJob.OrganizationFilter,
        CategoryFilter: requestJob.CategoryFilter,
        StatusFilter: requestJob.StatusFilter,
        SortBy: requestJob.SortBy,
        SortOrder: requestJob.SortOrder,
      });
      setLimit(item);
      setPage(1);
    },
  };
  const srcFileDownload = (row: any) => {
    const obj = {
      isShow: true,
      downloadGuid: row.documentsStoreId,
    };
    dispatch(updateDownloadID(obj));
  };

  const errFileDownload = (row: any) => {
    const obj = {
      isShow: true,
      downloadGuid: row.errorDocumentsStoreId,
    };
    dispatch(updateDownloadID(obj));
  };

  const bulkUploadKeyword = async () => {
    dispatch(updateIsLoading(true));
    const formData = new FormData();
    formData.append('id', id as string);
    formData.append('File', file_upload);
    await instance
      .post(`/categories/${id}/bulk-keyword`, formData)
      .then((response) => {
        if (response.status === 200) {
          getJobs({
            ...requestJob,
            Page: page,
            PageSize: limit,
            organizationFilter: requestJob.OrganizationFilter,
            CategoryFilter: requestJob.CategoryFilter,
            StatusFilter: requestJob.StatusFilter,
          });
          setFile_upload(null);
          const obj = {
            isOpen: true,
            message: successMessage.FILE_UPLOAD,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
          dispatch(updateIsLoading(false));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  return (
    <>
      <div
        className={`p-4 sm:flex ${
          props.isActive ? 'justify-between' : 'justify-end'
        }`}
      >
        {file_upload === null && props.isActive && (
          <div className="max-w-xl shadow-md">
            <label className="flex justify-center w-full h-24 px-4 transition bg-slate-50 border border-gray-300  rounded-md appearance-none cursor-pointer hover:border-gray-400 focus:outline-none">
              <span className="flex items-center space-x-4">
                <i className="fa-solid fa-cloud-arrow-up text-[60px] text-[#2d2d46]"></i>
                <span className="font-medium text-gray-600 hidden md:block">
                  Select file to upload the
                  <span className="text-blue-600 underline"> keywords</span>
                </span>

                <span className="md:hidden">Upload file</span>
              </span>
              <input
                type="file"
                name="file_upload"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                className="hidden"
                value={file_upload}
                onChange={handleFileChange}
              />
            </label>
          </div>
        )}{' '}
        {file_upload !== null && (
          <div className="m-2">
            <div className="mb-4 text-sm ">
              {' '}
              Upload the file? selected - {fileName}{' '}
            </div>
            <div className="flex items-center space-x-4">
              <Button
                label="Upload"
                buttonType="primary"
                type="button"
                onClick={() => bulkUploadKeyword()}
              />
              <Button
                label="Cancel"
                buttonType="danger"
                type="button"
                onClick={() => setFile_upload(null)}
              />
            </div>
          </div>
        )}
        {props.isActive && (
          <div>
            <div className="lg:mt-0 mt-2">
              <a
                href={`${process.env.REACT_APP_API_BASEURL}/templates/BulkKeywordUploadTemplate.xlsx`}
                className="flex items-center space-x-4 mb-4"
              >
                <div className="text-sm hidden md:block">{`Don't have the template? Click Here*`}</div>
                <div className="text-sm  md:hidden">{`Download template? Click Here*`}</div>
                <a className="text-sm border border-blue-500 px-4 py-2 text-blue-500 rounded-full cursor-pointer shadow-md flex items-center">
                  <i className=" animate-bounce fa-solid fa-cloud-arrow-down text-[18px] mr-2 text-blue-500"></i>{' '}
                  <div>Download</div>{' '}
                  <div className="hidden sm:flex"> &nbsp;Template</div>
                </a>
              </a>
            </div>
            <div className=" flex justify-end">
              <div
                onClick={() =>
                  getJobs({
                    ...requestJob,
                    Page: page,
                    PageSize: limit,
                    organizationFilter: requestJob.OrganizationFilter,
                    CategoryFilter: requestJob.CategoryFilter,
                    StatusFilter: requestJob.StatusFilter,
                  })
                }
                className="flex items-center justify-end space-x-2 px-2 py-1 border w-fit rounded-sm text-blue-500 border-blue-500 text-sm  cursor-pointer shadow-sm"
              >
                <div> Refresh</div>
                <div>
                  <i className="fa-solid fa-arrows-rotate"></i>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="lg:flex items-start justify-between mb-1 text-sm mx-4">
        <div className="text-lg text-[#444242]">Upload details</div>
        <div>
          <EllipsisHanlder
            word={props.categoryName}
            NoOfChar={20}
            label={'Category'}
          />
        </div>
        <div>
          <EllipsisHanlder
            word={props.categoryLabelName}
            NoOfChar={20}
            label={'Lable'}
          />
        </div>
      </div>
      <div className="bg-slate-100 rounded-md border">
        <div>
          <MuiTable
            columns={columns}
            rows={state}
            onSortHandler={sortRecord}
            onSrcFileDownload={srcFileDownload}
            onErrFileDownload={errFileDownload}
            sortOrder={requestJob.SortOrder}
            checkBoxShow={false}
            checkBoxValue={'titleCode'}
            page={page}
            limit={limit}
            paginateHandler={paginateHandler}
            totalRowCount={totalRowCount}
            sortArray={['organizationName', 'createdDate']}
          />
        </div>
      </div>
    </>
  );
};

export default Bulkupload;
